export default "__VITE_PUBLIC_ASSET__3a80c8c5__"